var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#E4E4E4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 15.3333C12.0333 15.3333 15.3333 12.0333 15.3333 8C15.3333 3.96667 12.0333 0.666672 7.99999 0.666672C3.96666 0.666672 0.666656 3.96667 0.666656 8C0.666656 12.0333 3.96666 15.3333 7.99999 15.3333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16666 7.99999L7.05332 9.88666L10.8333 6.11333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "tick"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTickCircle);
export default __webpack_public_path__ + "static/media/bfid-tick-circle.d0406c10bfdc69089d740de79e5b6454.svg";
export { ForwardRef as ReactComponent };